export const kratos_login_flow = {
  login_failed: "Sign-in failed.",
  no_account: "Don't have an account?",
  link_sign_up: "Sign up",
};
